module.exports = __webpack_public_path__ + "static/media/origin-bg.d9563d30.png";